import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Checkbox } from '@paypalcorp/pp-react';
import DonateGiftAidHowItWorksOverlay from './DonateGiftAidHowItWorksOverlay';

const styles = StyleSheet.create({
	centered: {
		display: 'flex',
		justifyContent: 'center'
	},
	toolCheckbox: {
		':before': {
			overflow: 'hidden',
		},
	},
	helpIcon: {
		position: 'relative',
		color: '#005EA6',
		cursor: 'pointer',
		textDecoration: 'none',
		top: 3
	},
	giftaidit: {
		padding: '25px 38px',
		border: '1px solid #ccc',
		borderRadius: 8,
		width: '100%',
		margin: '10px auto 15px auto',
		maxWidth: 400
	},
	imgWrapper: {
		display: 'block',
		margin: '0px auto 8px auto'
	},
	showHelp: {
		color: '#848b8e',
		marginTop: 15,
		marginLeft: 42,
		textAlign: 'left'
	},
		giftaidNote: {
		marginBottom: 20,
		fontSize: 14,
		textAlign: 'left' 
	},
	pTag: {
		fontSize: 14,
		marginBottom: 15,
		textAlign: 'left'
	},
	showAddres: {
		marginTop: 15,
		marginLeft: 42,
		color: '#2c2e2f',
		borderBottom: '1px solid #ccc',
		paddingBottom: 13,
		textAlign: 'left'
	},
	listUnstyled: {
		margin: 0,
		listStyle: 'none'
	},
	liTag: {
		marginBottom: 2
	},
	successIcon: {
		marginLeft: -5,
		paddingRight: 5,
		color: '#00cf92'
	},
	modalContent: {
		background: 'none',
		boxShadow: 'none'
	},
	modalHeader: {
		textAlign: 'right'
	},
	alreadyEnabled: {
		textAlign: 'left',
		fontSize: 14
	},
	updateGiftAidDeclaration: {
		borderTop: '1px solid #ccc',
		paddingTop: 15,
		fontSize: 14
	}
});

class DonateGiftAid extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showhelp: this.props.isAlreadyEnrolled ? false : this.props.isChecked,
			isChecked: this.props.isChecked || false,
			isHowItWorksOverlayOpen: false
		};
		this.handleGiftAidOption = this.handleGiftAidOption.bind(this);
	}	

	handleGiftAidOption(ev) {
		let isChecked = ev.target.checked;
		this.setState({
			showhelp: isChecked,
			isChecked: isChecked
		});
		this.props.handleGiftAidOption(isChecked);
	}

	createMarkup(content) {
		return {
			__html: content
		};
	}

	handleTipClick = () => {
		event.preventDefault();
		this.setState({
			isHowItWorksOverlayOpen: true
		})
	}

	createLabel = (label) => {
		return (
			<p className="ppvx_text--md no-margins">{label}
				<a href="#" onClick={this.handleTipClick}>
					<span className="ppvx_icon ppvx_icon--size_xs ppvx_icon-question-alt paypal-color"></span>
				</a>
			</p>
		)
	}

	openHowItWorksOverlay = () => {
		this.setState({
			isHowItWorksOverlayOpen: true
		})
	}

	closeHowItWorksOverlay = () => {
		this.setState({
			isHowItWorksOverlayOpen: false
		})
	}

	render () {

		let contentMsg = this.props.contentMsg;

		return (
            <div className="ppvx_row">
				<div className="ppvx_col-12">
					<div className={`${css(styles.centered)}`}>
						<div className={`${css(styles.giftaidit)}`}>
							<img className={`${css(styles.imgWrapper)}`} src="https://www.paypalobjects.com/webstatic/ppgf/giftaid/GiftAidWPS.png" alt="giftaidit" />
							<p className={`${css(styles.giftaidNote)}`} dangerouslySetInnerHTML={this.createMarkup(contentMsg.extraCost)}></p>

							{(this.props.isAlreadyEnrolled) && <div className={css(styles.alreadyEnabled)}>
								<span className={`icon icon-positive-large icon-medium ${css(styles.successIcon)}`}></span>
								<span>{contentMsg.alreadyDone}</span>
								<a href="#" className={`icon icon-small icon-tooltip-outline-small ${css(styles.helpIcon)}`} aria-hidden="true" id="tiphelpIcon" 
									data-toggle="modal" 
									data-target="#giftaiditModal">
								</a>
								{this.props.isMember && <p className={`${css(styles.updateGiftAidDeclaration)}`}>{contentMsg.updateGiftAidDeclaration}</p>}
							</div>}

							{(!this.props.isAlreadyEnrolled) &&
								<div>
									<Checkbox
										label={this.createLabel(contentMsg.optGiftaid)}
										name="giftaidCheckbox"
										id="giftaidCheckbox"
										onChange={this.handleGiftAidOption}
										checked={this.state.isChecked}
									/>
								</div>
							}

							{this.state.showhelp && <div>
								<div className={`${css(styles.showHelp)}`}>
									<p className={`${css(styles.pTag)}`}>{contentMsg.applyGiftAid}</p>
								</div>
								{this.props.showAddress && <div className={`${css(styles.showAddres)}`}>
									<p><b>{contentMsg.taxpayer}</b></p>
									<ul className={`list-unstyled ${css(styles.listUnstyled)}`}>
									<li className={`${css(styles.liTag)}`}>{this.props.addressData.fullName}</li>
									<li className={`${css(styles.liTag)}`}>{this.props.addressData.address1}</li>
									<li className={`${css(styles.liTag)}`}>{this.props.addressData.address2}</li>
									<li className={`${css(styles.liTag)}`}>{this.props.addressData.city}</li>
									<li className={`${css(styles.liTag)}`}>{this.props.addressData.state}, {this.props.addressData.zip}</li>
									</ul>
								</div>}
								<div className={`${css(styles.showHelp)}`}>
								<p className={`${css(styles.pTag)}`}>{contentMsg.confirmNote}</p>
								{this.props.isMember && <p className={`${css(styles.updateGiftAidDeclaration)}`}>{contentMsg.updateGiftAidDeclaration}</p>}
								</div>
							</div>}

							<DonateGiftAidHowItWorksOverlay
								isOpen={this.state.isHowItWorksOverlayOpen}
								openOverlay={this.openHowItWorksOverlay}
								closeOverlay={this.closeHowItWorksOverlay}
								content={contentMsg}
							/>
							</div>
					</div>
				</div>
				
			</div>
        );
	}
}

DonateGiftAid.propTypes = {	
	isAlreadyEnrolled: PropTypes.bool,
	showAddress: PropTypes.bool,
	addressData: PropTypes.any,
	isChecked: PropTypes.bool,
	handleGiftAidOption: PropTypes.func,
	contentMsg: PropTypes.object,
	isMember: PropTypes.bool,
};

export default DonateGiftAid;